import { useState } from 'react';
import { useCommonDataContext } from '@/common/hooks/commonDataContext';

const useSuperProductList = () => {
	const [editingSuperProduct, setEditingSuperProduct] = useState();
	const {
		commonData: { products, superProducts },
		queryValues: { isLoading },
	} = useCommonDataContext();

	const sortedSuperProducts = (superProducts || [])
		.slice()
		.sort((left, right) => left.name.localeCompare(right.name));

	const closeForm = () => {
		setEditingSuperProduct(undefined);
	};

	const openCreateForm = () => {
		setEditingSuperProduct(null);
	};

	const handleSaved = () => {
		closeForm();
	};

	const openEditForm = (row) => {
		const superProduct = sortedSuperProducts.find((item) => item._id === row._id);

		if (!superProduct) {
			return;
		}

		setEditingSuperProduct(superProduct);
	};

	const rows = sortedSuperProducts.map((superProduct) => ({
		data: [superProduct.name],
		_id: superProduct._id,
	}));

	return {
		rows,
		products: products || [],
		editingSuperProduct,
		isLoading,
		openCreateForm,
		openEditForm,
		closeForm,
		handleSaved,
	};
};

export default useSuperProductList;
